import { Component, OnInit } from '@angular/core';
import { LoadingService } from 'src/app/utils/services/loading.service';

@Component({
  selector: 'app-mini-spinner',
  templateUrl: './mini-spinner.component.html',
  styleUrls: ['./mini-spinner.component.scss']
})
export class MiniSpinnerComponent implements OnInit {

  constructor(public loadingService: LoadingService){}

  ngOnInit(): void {
  }

}
